
export function create_mb_header_data() {
    const data = {
        mb_header_background: {
            radio_val: 'default',
            default: {
                type: 'color', // 背景设置-类型
                img: '', // 背景设置-图片的URL
                color: 'rgba(255, 255, 255,1)', // 背景设置-颜色
                img_scale: 'scale_tiling', //图片缩放 填充、等比例、平铺、拉伸、原图
                tile_effect: 'img_default', //平铺效果 默认、缩放平铺、上、中-横向、下、中-纵向、左、右
                background_size: 'cover',
                background_repeat: 'no-repeat',
                background_position: 'center center' //图片位置
            },
            custom: {
                type: 'color', // 背景设置-类型
                img: '', // 背景设置-图片的URL
                color: 'rgba(255, 255, 255,1)', // 背景设置-颜色
                img_scale: 'scale_tiling', //图片缩放 填充、等比例、平铺、拉伸、原图
                tile_effect: 'img_default', //平铺效果 默认、缩放平铺、上、中-横向、下、中-纵向、左、右
                background_size: 'cover',
                background_repeat: 'no-repeat',
                background_position: 'center center' //图片位置
            }
        },

        //移动端顶部导航颜色
        mb_header_btn_background: {
            radio_val: 'default',
            default: {
                color: 'rgba(0, 0, 0,1)',
            },
            custom: {
                color: 'rgba(0, 0, 0,1)',
            }
        },
    }

    return data
}



// WEBPACK FOOTER //
// ./src/base/mb_header_data.js